import { createSlice } from '@reduxjs/toolkit'
import { fetchCompatibility } from '../../../application/usecases/fetchCompatibility.ts'

interface HoroscopeState {
  data: any | null
  loading: boolean
  error: string | null
}

const initialState: HoroscopeState = {
  data: null,
  loading: false,
  error: null,
}

const horoscopeSlice = createSlice({
  name: 'horoscope',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCompatibility.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchCompatibility.fulfilled, (state, action) => {
        state.loading = false
        state.data = action.payload
      })
      .addCase(fetchCompatibility.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message || 'Error desconocido'
      })
  },
})

export default horoscopeSlice.reducer
